import React, { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import img from "../assets/gaminggear-banner.webp";

gsap.registerPlugin(ScrollTrigger);

function GamingGearBanner() {
  const sectionRef = useRef(null);

  useLayoutEffect(() => {
    if (!sectionRef.current) {
      return undefined;
    }

    const ctx = gsap.context(() => {
      gsap.fromTo(
        ".gaminggear__desc > *",
        {
          y: 36,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.85,
          stagger: 0.1,
          ease: "power3.out",
          clearProps: "opacity,transform",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 82%",
            once: true,
          },
        }
      );

      gsap.fromTo(
        ".gaminggear__img",
        {
          y: 28,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.95,
          ease: "power3.out",
          clearProps: "opacity,transform",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 82%",
            once: true,
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="gaminggear__container container" ref={sectionRef}>
      <div className="gaminggear__wrapper">
        <div className="gaminggear__desc">
          <span className="gaminggear__eyebrow">За гејмери и креатори</span>
          <h2>Професионална опрема за гејминг, стриминг и креативна работа.</h2>
          <p>
            Слушалки, периферија и гејминг додатоци од врвен квалитет за подобро
            гејминг искуство.
          </p>
          <a
            href="/galanterija/gslusalki"
            className="hero-banner__button hero-banner__button--solid"
          >
            Разгледај повеќе
          </a>
        </div>
        <div className="gaminggear__img">
          <img src={img} alt="Гејминг опрема" />
        </div>
      </div>
    </section>
  );
}

export default GamingGearBanner;
